// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import searchRefractionIcon from "@/assets/icons/search-refraction.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type SearchRefractionIconProps = Omit<IconProps, "name">;

export function SearchRefractionIcon(props: SearchRefractionIconProps): React.ReactNode {
  return <Icon name={searchRefractionIcon} {...props} />;
}
